module.exports = __webpack_public_path__ + "static/media/server-solid.92c7d580.svg";